/**
 * @Author: ZLZ
 * @Date: 2025-12-29 14:54
 * @Description: 2.0 内容 龙湖掘金 路由模块
 */
import Layout from "@/Layout";
export default [
  {
    path: "/jiGouDongXiang",
    component: Layout,
    name: "JiGouDongXiang",
    redirect: "/jiGouDongXiang/index",
    children: [
      {
        path: "index",
        component: () => import("@/views/jiGouDongXiang/index.vue"),
        meta: {
          title: "机构动向",
          keepAlive: false,
          showFooter: false,
          showHead: true,
          showLeft: true,
          showRight: false
        }
      },
      {
        path: 'detail',
        component: () => import("@/views/jiGouDongXiang/detail.vue"),
        meta: {
          title: "机构动向",
          keepAlive: false,
          showFooter: false,
          showHead: true,
          showLeft: true,
          showRight: false
        }
      }
    ]
  },
];
